<div
  infinite-scroll
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollUpDistance]="scrollUpDistance"
  [infiniteScrollThrottle]="throttle"
  [infiniteScrollDisabled]="infiniteScrollDisabled"
  (scrolled)="scrollDownEvent.emit($event)"
>
  <ng-content></ng-content>
</div>
